'use client';

import CampaignSession from '../session/campaign-session';
import StoreList from '../store-list-client';
import { useGetStores } from '@/api/use-get-store';
import type { PageContentProps } from '@/types/page-types';

export default function CampaignPageContent({ payload }: PageContentProps) {
  const { data: storesData } = useGetStores(payload, {
    enabled: !!payload.campaign_id,
  });

  if (!payload.campaign_id) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF7F2] via-white to-[#EAECEF]">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-12 py-6">
        <CampaignSession
          campaignId={payload.campaign_id}
          city={payload.city_id}
        />
        <StoreList payload={payload} data={storesData?.stores ?? []} />
      </div>
    </div>
  );
}
